"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var NewLayover = function NewLayover() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.4731 14.5269L14.5269 13.4731L10.75 9.6959V4.99998H9.25V10.3038L13.4731 14.5269ZM10.0016\n19.5C8.68772 19.5 7.45268 19.2506 6.29655 18.752C5.1404 18.2533 4.13472 17.5765 3.2795\n16.7217C2.42427 15.8669 1.74721 14.8616 1.24833 13.706C0.749442 12.5504 0.5 11.3156 0.5 10.0017C0.5\n8.68772 0.749334 7.45268 1.248 6.29655C1.74667 5.1404 2.42342 4.13472 3.27825 3.2795C4.1331 2.42427\n5.13834 1.74721 6.29398 1.24833C7.44959 0.749443 8.68437 0.5 9.9983 0.5C11.3122 0.5 12.5473\n0.749334 13.7034 1.248C14.8596 1.74667 15.8652 2.42342 16.7205 3.27825C17.5757 4.1331 18.2527\n5.13834 18.7516 6.29398C19.2505 7.44959 19.5 8.68437 19.5 9.9983C19.5 11.3122 19.2506 12.5473\n18.752 13.7034C18.2533 14.8596 17.5765 15.8652 16.7217 16.7205C15.8669 17.5757 14.8616 18.2527\n13.706 18.7516C12.5504 19.2505 11.3156 19.5 10.0016 19.5ZM9.99998 18C12.2166 18 14.1041 17.2208\n15.6625 15.6625C17.2208 14.1041 18 12.2166 18 9.99998C18 7.78331 17.2208 5.89581 15.6625\n4.33748C14.1041 2.77914 12.2166 1.99998 9.99998 1.99998C7.78331 1.99998 5.89581 2.77914 4.33748\n4.33748C2.77914 5.89581 1.99998 7.78331 1.99998 9.99998C1.99998 12.2166 2.77914 14.1041 4.33748\n15.6625C5.89581 17.2208 7.78331 18 9.99998 18Z",
    fill: "#6E6D71"
  }));
};
var _default = NewLayover;
exports.default = _default;